const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsTennis = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 21.6.9-.6c3-2.3-.2-8-2.3-10-1.6-1.6-6.7-4.2-7-6.3-.1-1 1.5-1.6 2.2-2A10 10 0 0 1 22 12.2c0 4.5-3.2 8.5-7.5 9.5Z",
    style: {
      fill: "none",
      stroke: "#00a000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.9,
    cy: 12,
    r: 10,
    style: {
      fill: "none",
      stroke: "#00a000",
      strokeWidth: 2
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsTennis);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons_tennis_.d7ab37bacbd5b5037ed3bf3b012fe6f6.svg";